var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "subscription-competition-view flex-between-wrapper" },
    [
      _c("div", { staticClass: "premium-competition-view" }, [
        _c("h3", { staticClass: "view-title" }, [
          _vm._v("Motivate students to reach their full potential."),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "view-description" }, [
          _vm._v(
            "With Premium you can deeply engage students with classroom competitions, badges, prizes, and more! Bonus - students can track their own progress and have agency over their achievements."
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "button-wrapper" },
          [
            _c("primary-button", { on: { click: _vm.handleClickPlan } }, [
              _vm._v("Choose your plan"),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("img", {
        staticClass: "feature-image",
        attrs: { src: "/assets/app/class/competition-frame-bg.png" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }